import { useState, useCallback } from 'react';
import { apiRequest } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { useEmpresaSelector } from '../context/EmpresaSelectorContext';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { isAdmin, usuario } = useAuth();
  const { empresaSeleccionada } = useEmpresaSelector();

  const request = useCallback(async (endpoint, options = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await apiRequest(endpoint, options);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'Error en la petición');
      }
      
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const get = useCallback(async (endpoint, params = {}) => {
    // Agregar empresaId según la empresa seleccionada o la empresa del usuario
    if (empresaSeleccionada) {
      params.empresaId = empresaSeleccionada.id;
    } else if (!isAdmin() && usuario?.empresaId) {
      params.empresaId = usuario.empresaId;
    }
    
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    
    return request(url);
  }, [isAdmin, usuario, empresaSeleccionada, request]);

  const post = useCallback(async (endpoint, data = {}) => {
    // Agregar empresaId según la empresa seleccionada o la empresa del usuario
    if (empresaSeleccionada) {
      data.empresaId = empresaSeleccionada.id;
    } else if (!isAdmin() && usuario?.empresaId) {
      data.empresaId = usuario.empresaId;
    }
    
    return request(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }, [isAdmin, usuario, empresaSeleccionada, request]);

  const put = useCallback(async (endpoint, data = {}) => {
    // Agregar empresaId según la empresa seleccionada o la empresa del usuario
    if (empresaSeleccionada) {
      data.empresaId = empresaSeleccionada.id;
    } else if (!isAdmin() && usuario?.empresaId) {
      data.empresaId = usuario.empresaId;
    }
    
    return request(endpoint, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  }, [isAdmin, usuario, empresaSeleccionada, request]);

  const del = useCallback(async (endpoint) => {
    return request(endpoint, {
      method: 'DELETE',
    });
  }, [request]);

  return { 
    request, 
    get, 
    post, 
    put, 
    del, 
    loading, 
    error 
  };
};
